<template>
<div>
  <vs-popup class="holamundo" :title="$t('message.payment.confirmPaymentBySms')" :active.sync="smsForm">
    <div>
      <vs-alert :color="error ? 'danger' : 'success'" v-if="errorText.length > 0">
        {{ errorText }}
      </vs-alert>
      <label>
        <span>{{ $t(`message.payment.confirmPayment${useOtpPayments?'Otp':'Sms'}`) }}</span>
        <vs-input
          name="smsCode"
          v-model="smsCode"
          :danger="error"
          @keydown.enter.prevent.stop="confirmSignCode"
          class="w-1/6 my-6 ml-5 inline-block"/>
      </label>
    </div>
    <div class="mb-6">
      {{ $t('message.payment.confirmPaymentPhone', {phone: ''}) }}
    </div>
    <div class="mb-6">
      <a href="javascript: void(0)" v-if="smsSecond === 0" @click="getSignCode">
        {{ $t('message.payment.confirmPaymentSmsSecond') }}
      </a>
      <span v-if="smsSecond > 0">
        {{ $t('message.payment.confirmPaymentSmsAfter', {seconds: this.smsSecond}) }}
      </span>
    </div>
    <p class="mb-6" v-if="false" v-html="$t('message.payment.confirmPaymentSmsText')"></p>
    <vs-button @click="confirmSignCode" line-origin="center" v-if="$checkRole('director')"
               color="primary" type="gradient" class="float-right mt-6">
      {{ $t('message.payment.confirmPaymentSmsConfirm') }} >
    </vs-button>
  </vs-popup>
  <div class="mt-8 w-full">
    <div class="flex mb-4">
      <div class="text-right mr-4 font-bold text-primary">{{ $t('message.salaryProject.formPaymentNumber') }}</div>
      <div>{{ data.head.id }}</div>
    </div>
    <div class="flex mb-4">
      <div class="text-right mr-4 font-bold text-primary">{{ $t('message.salaryProject.formPaymentBill') }}</div>
      <div>{{ data.paymentBill }}</div>
    </div>
    <div class="flex mb-4">
      <div class="text-right mr-4 font-bold text-primary">{{ $t('message.salaryProject.formPaymentContact') }}</div>
      <div>{{ data.head.contact_name }}</div>
    </div>
    <div class="flex mb-4">
      <div class="text-right mr-4 font-bold text-primary">{{ $t('message.salaryProject.formPaymentPhone') }}</div>
      <div>{{ data.head.contact_phone }}</div>
    </div>
  </div>
  <div>
    <vs-table
      stripe :data="tableBody" pagination :maxItems="30"
      class="w-full mt-4" :noDataText="$t('message.salaryProject.noDataText')">
      <template slot="thead">
        <vs-th>{{ $t('message.salaryProject.tableHeaderFio') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderPost') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderMain') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderAmount') }}</vs-th>
      </template>
      <template :slot-scope="{tableBody}">
        <template  v-for="(row, index) in tableBody">
          <vs-tr :key="`${index}data`">
            <vs-td>{{ row.fio }}</vs-td>
            <vs-td>{{ row.post }}</vs-td>
            <vs-td>{{ row.bill }}</vs-td>
            <vs-td>{{ row.amount }}</vs-td>
          </vs-tr>
        </template>
      </template>
    </vs-table>
  </div>
  <div class="w-fill">
    <div class="w-2/3 mt-2">
      <vs-button @click="$emit('back-button')" line-origin="center"
                 color="primary" type="flat" class="mt-6 mr-4">
        &lt; {{ $t('message.payment.backButton') }}
      </vs-button>
      <vs-button @click="$emit('edit-button')" line-origin="center"
                 color="primary" type="flat" class="mt-6 mr-4">
        &lt; {{ $t('message.payment.editButton') }}
      </vs-button>
      <vs-button @click="getSignCode" line-origin="center" v-if="$checkRole('director')"
                 color="primary" type="gradient" class="mt-6">
        {{ $t('message.payment.signButton') }} &gt;
      </vs-button>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'SignCode',
  props: ['data'],
  data: () => ({
    smsCode: '',
    smsForm: false,
    error: null,
    smsSecond: false,
    smsTimer: null,
    errorText: ''
  }),
  methods: {
    ...mapActions('salary', ['getActSign', 'confirmSmsCode']),
    async getSignCode () {
      if (await this.getActSign(this.data.head.id)) {
        this.smsForm = true
        this.error = false
        this.smsSecond = 60
        this.smsTimer = window.setInterval(() => {
          if (this.smsSecond > 0) this.smsSecond -= 1
          else if (this.smsSecond === 0) {
            window.clearTimeout(this.smsTimer)
          }
        }, 1000)
      }
    },
    async confirmSignCode () {
      this.error = false
      this.errorText = ''
      const result = await this.confirmSmsCode({
        actId: this.data.head.id,
        userCode: this.smsCode
      })
      if (result === true) {
        this.errorText = this.$t('message.salaryProject.successSign')
        window.setTimeout(() => {
          this.smsForm = false
          this.$emit('close-form')
        }, 5000)
      } else {
        this.errorText = this.$t('message.salaryProject.someError')
        this.error = true
      }
    }
  },
  computed: {
    ...mapGetters('utils', ['getUserRole']),
    ...mapGetters('user', ['useOtpPayments']),
    tableBody () {
      return this.data.body
    },
    haveError () {
      return this.tableBody.some((item) => item.salary_error)
    }
  },
  watch: {
    smsForm (val) {
      if (val === false) this.smsCode = ''
    }
  }
}
</script>

<style scoped>

</style>
